export const BACKEND =
  process.env.REACT_APP_BACKEND_URL || 'http://localhost:65002'
